// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

import Icon from './Icon';

window.$RefreshReg$ = () => {};

const DismissIcon = styled.div`
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;
`;

type CardStructureProps = {
  children: Node,
  // Cards are optionally "dismissible" - if a value is provided for the onDismiss event, then an
  // "x" icon is displayed in the upper right corner of the card
  onDismiss?: () => void,
};

const CardStructure = ({ children, onDismiss, ...props }: CardStructureProps) => (
  <div {...props}>
    {typeof onDismiss === 'function' && (
      <DismissIcon onClick={() => onDismiss()}>
        <Icon icon="close" size="small" />
      </DismissIcon>
    )}
    {children}
  </div>
);

CardStructure.defaultProps = {
  onDismiss: null,
};

const Card = styled(CardStructure)`
  background: ${colors.white};
  border-radius: 4px;
  box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.25);
  margin: 24px auto;
  max-width: 800px;
  padding: 20px;
  position: relative;
`;

export default Card;
